import React from "react";
import { cn } from "../../utils/lib";

export function PriceIcon({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      className={cn("w-full h-auto", className)}
      {...props}
    >
      <path
        d="M3.47483 12.7492L7.24983 16.5242C8.79983 18.0742 11.3165 18.0742 12.8748 16.5242L16.5332 12.8659C18.0832 11.3159 18.0832 8.79919 16.5332 7.24085L12.7498 3.47419C11.9582 2.68252 10.8665 2.25752 9.74983 2.31585L5.58316 2.51585C3.9165 2.59085 2.5915 3.91585 2.50816 5.57419L2.30816 9.74085C2.25816 10.8659 2.68316 11.9575 3.47483 12.7492Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.91634 10.0007C9.06693 10.0007 9.99967 9.06791 9.99967 7.91732C9.99967 6.76672 9.06693 5.83398 7.91634 5.83398C6.76575 5.83398 5.83301 6.76672 5.83301 7.91732C5.83301 9.06791 6.76575 10.0007 7.91634 10.0007Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
